import { Icon, Text, useClipboard } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { RiCheckLine, RiFileCopyLine } from "react-icons/ri";
import { useAvelaToast } from "src/hooks/useAvelaToast";

type CopyToClipboardProps = PropsWithChildren<{
  text: string;
}>;

export const CopyToClipboard = ({
  text,
  children = text,
}: CopyToClipboardProps) => {
  const { hasCopied, onCopy } = useClipboard(text, { timeout: 5000 });
  const toast = useAvelaToast();
  const handleCopy = () => {
    onCopy();
    toast({
      title: "Copied to clipboard",
      description: `"${text}" has been copied`,
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };
  return (
    <Text as="span" onClick={handleCopy} cursor="pointer" color="primary.500">
      {children}{" "}
      <Icon
        as={hasCopied ? RiCheckLine : RiFileCopyLine}
        verticalAlign="middle"
      />
    </Text>
  );
};
